import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2815b5ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "qrcode-wrapper" }
const _hoisted_2 = { class: "qrcode-wrapper__img-border" }
const _hoisted_3 = { class: "qrcode-wrapper__img-tips" }
const _hoisted_4 = { class: "download-qrcode-btn__text" }
const _hoisted_5 = { class: "qrcode-wrapper__footer-text" }

import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import vueQr from 'vue-qr/src/packages/vue-qr.vue'
// 国际化

export default /*#__PURE__*/_defineComponent({
  __name: 'qrCodeDialog',
  props: {
    qrCodeUrl: null,
    qrTitle: null
  },
  setup(__props: any) {

const props = __props as {
  qrCodeUrl: string
  qrTitle?: string
}

const { t } = useI18n()
const tBasePrefix = ref<string>('components.dialog.qrCode')
const qrCode = ref<{ imgUrl: string }>()

// 下载二维码
const downloadQRCodeImg = () => {
  const a = document.createElement('a')
  a.download = props.qrTitle
    ? props.qrTitle
    : t(`${tBasePrefix.value}.downloadImageName`)
  if (qrCode.value) {
    a.href = qrCode.value.imgUrl
  }
  a.click()
}

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(vueQr, {
        ref_key: "qrCode",
        ref: qrCode,
        text: __props.qrCodeUrl,
        size: 188,
        margin: 6
      }, null, 8, ["text"])
    ]),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t(`${tBasePrefix.value}.sweepThePhone`)), 1),
    _createVNode(_component_n_button, {
      class: "download-qrcode-btn",
      type: "primary",
      onClick: downloadQRCodeImg
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t(`${tBasePrefix.value}.downloadImage`)), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t(`${tBasePrefix.value}.tipsShareFriends`)), 1)
  ]))
}
}

})